import "../sass/child-styles.scss"

import DynamicSiteLogo from "./modules/./DynamicSiteLogo";

const dynamicSiteLogo = new DynamicSiteLogo();